import {useWatch} from 'react-hook-form'

import {useFieldConfigurationContext} from '../../configuration/useConfigurationContext'
import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'

export const usePlusLoadExpected = () => {
  const {
    control,
    setValue,
    trigger,
    formState: {defaultValues}
  } = useOrderProcessFormContext()
  const plusLoadConfiguration = useFieldConfigurationContext('plusLoadExpected')
  const plusLoad = useWatch({name: 'plusLoadExpected', control})
  const defaultPlusLoad = defaultValues?.plusLoadExpected

  const setPlusLoad = (newPlusLoad: boolean) => {
    // send analytics
    setValue('plusLoadExpected', newPlusLoad)
    trigger().catch((error) => {
      console.error('Error triggering validation:', error)
    })
  }

  return {
    plusLoad,
    defaultPlusLoad,
    setPlusLoad,
    ...plusLoadConfiguration
  }
}
